import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { Handle, useReactFlow } from "react-flow-renderer";
import { Fetcher } from "../../../../Helpers/fetcher";
import { Notify } from "../../../../Helpers/notification";
import { NodesContext } from "../../provider/IvrContext";
import AudioPreviewModal from "../AudioPreviewModal";

const PlayNode = ({ data, id }) => {
    const { setNodes } = useReactFlow();

    const { updateNodeData, onRemove, audioList } = useContext(NodesContext)
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [errors, setErrors] = useState({});
    const [playModalOpen, setPlayModalOpen] = useState(false);

    // ✅ derive from node data
    const action = data.action || {};
    const audioId = action.id || "";
    const audioUrl = action.audio || "";
    const audioName = action.name || "";

    const updateNode = (updates) => {
        updateNodeData(id, updates);
    };

    const handleAudioChange = (e) => {
        const selected = audioList.find(
            (a) => a.promptId.toString() === e.target.value
        );

        if (!selected) return;

        updateNode({
            action: {
                type: "play",
                id: selected.promptId,
                audio: selected.promptUrl,
                duration: selected.promptDuration ? selected.promptDuration : "",
                name: selected.fileName
            },
        });
    };

    const validateForm = () => {
        const newErrors = {};
        console.log("++++" + !action?.id);
        if (!action?.id) {
            newErrors.audio = 'Audio is required';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSave = () => {

        if (!validateForm()) return;

        Notify.notify("Details updated successfully");
        setModalIsOpen(false);
    };

    const handleRemoveNode = () => {
        if (data.parent === "gather Node" && data.idToRemove) {
            setNodes((nodes) =>
                nodes.map((node) => {
                    if (!node.data.selectedHandles) return node;

                    const updatedHandles = { ...node.data.selectedHandles };
                    const updatedSmsData = { ...node.data.smsData }
                    delete updatedHandles[data.idToRemove];
                    if (updatedSmsData) {
                        const parts = data.idToRemove.split('-');
                        const handleIndex = parts[parts.length - 1];
                        if (handleIndex) {
                            const smsKey = `DTMF_${handleIndex}`;
                            delete updatedSmsData[smsKey]
                        }
                    }
                    return {
                        ...node,
                        data: { ...node.data, selectedHandles: updatedHandles, smsData: updatedSmsData },
                    };
                })
            );
        }
        onRemove(id)
    };

    return (
        <div style={{ position: "relative", width: "65px", height: "40px" }}>
            <div
                style={{
                    position: "absolute",
                    top: 8,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    border: "1.5px solid #007bff",
                    borderRadius: "10px 10px 0 10px",
                    background: "#fff",
                    zIndex: 3,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    padding: "4px",
                    fontSize: "11px",
                }}
            >
                <Handle type="target" position="top" style={{ background: "#007bff" }} />
                <Handle type="source" position="bottom" style={{ background: "#007bff" }} />

                <span style={{ fontSize: "10px", fontWeight: "bold", textTransform: "capitalize" }}>
                    {data.label}
                </span>

                <div style={{ display: "flex", gap: "5px", paddingTop: "2px" }}>
                    <i
                        className="fa fa-cog"
                        style={{ color: "#007bff", cursor: "pointer" }}
                        onClick={() => setModalIsOpen(true)}
                    />
                    <i
                        className="fa fa-trash"
                        style={{ color: "#007bff", cursor: "pointer" }}
                        onClick={handleRemoveNode}
                    />
                    {audioUrl && (
                        <i
                            className="fa fa-play"
                            style={{ color: "#28a745", cursor: "pointer" }}
                            title="Play audio"
                            onClick={() => setPlayModalOpen(true)}
                        />
                    )}
                </div>
            </div>

            <Modal
                size="lg"
                show={modalIsOpen}
                onHide={() => setModalIsOpen(false)}
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Play</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Select Audio</Form.Label>
                            <Form.Control
                                as="select"
                                value={audioId}
                                onChange={handleAudioChange}
                            >
                                <option value="">Select Audio</option>
                                {audioList.map((item) => (
                                    <option key={item.promptId} value={item.promptId}>
                                        {item.fileName}
                                    </option>
                                ))}
                            </Form.Control>
                            {errors.audio && <Form.Text className="text-danger">{errors.audio}</Form.Text>}
                        </Form.Group>
                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={handleSave}>Save</Button>
                    <Button variant="secondary" onClick={() => setModalIsOpen(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <AudioPreviewModal
                show={playModalOpen}
                onClose={() => setPlayModalOpen(false)}
                audioUrl={audioUrl}
                title={audioName}
            />

        </div>
    );
};

export default PlayNode;
